<template>
	<div class="detrusion">
		<div class="title">指派给</div>
		<div class="detrusion-main">
			<div class="dtree-select" style="position:relative">
				<a-tree-select
						:getPopupContainer="triggerNode => triggerNode.parentNode"
						style="width: 100%;position:relative"
						:value="value"
						:dropdownStyle="{ maxHeight: '300px', overflow: 'auto' }"
						placeholder="请选择"
						:selectable="false"
						allowClear
						autoExpandParent
						showSearch
						@change="onChange"
						:treeData="treeData"
				>
				</a-tree-select>
			</div>
			<a-button type="primary" class="confirm-primary" @click="appointJobs()">确定</a-button>
		</div>
	</div>
</template>

<script>
  export default {
    data() {
      return {
        treeExpandedKeys: [],
        value: undefined,
        total: "",
        treeData: [],
        userId: "",
        ids: [],
        timeOut: null,
      };
    },
    props: ["selectedData"],
    mounted() {
    },
    methods: {
      onChange(value, label, extra) {
        this.value = value;
        let tag = value ? extra.triggerNode.eventKey.toString().substring(7) : '';
        this.userId = tag;
      },
      onSelect(data) {
      },
      // GET /api/jobsmanage/jobs/appointJobs
      //指派的效果
      appointJobs() {
        let _this = this;
        this.ids = [];
        for (let item of this.selectedData) {
          this.ids.push(item.id);
        }
        if (this.userId) {
          this.$get("jobsmanage/jobs/appointJobsAnalyze", {
            userId: this.userId,
            ids: this.ids
          }).then(res => {
            if (res.status == 200) {
              this.$message.success(res.data.message);
              setTimeout(() => {
                _this.$emit("close");
                _this.$emit('update')

              }, 200);
            }
          });
        } else {
          this.$message.error('请选择指派人')
        }

      },
      // 指派给某个人
      // onLoadData(treeNode) {
      //   let _this = this;
      //   return new Promise(resolve => {
      //     if (treeNode.dataRef.children.length > 0) {
      //       resolve();
      //       return;
      //     }
      //     // if (!treeNode.dataRef.children) {
      //     setTimeout(() => {
      //       _this
      //         .$get("/user", {
      //           deptId: treeNode.dataRef.deptId,
      //           // roleId:6,
      //         })
      //         .then(res => {
      //           let newData = res.data.rows;
      //           newData.map((item, index) => {
      //             item.title = item.nickName;
      //             item.selectable = true;
      //             item.key = _this.total + index + 2;
      //             item.value = "userId_" + item.userId;
      //             item.isLeaf = true;
      //             return item;
      //           });
      //           treeNode.dataRef.children = newData;
      //           _this.treeData = [..._this.treeData];
      //           resolve();
      //         });
      //     }, 1000);
      //     // }
      //   });
      // },
      getUser(id) {
        this.$get("/user", {
          deptId: id
        }).then(res => {

        });
      },
      // 查找组织机构
      // GET /api/dept/findDeptList
      findDeptList() {
        this.$get("dept/findDeptTreeList", {
          pageSize: 999999,
          pageNum: 1
        }).then(res => {
          this.treeData = res.data.data;
          this.treeData.map(item => {
            item.title = item.deptName;
            item.selectable = true;
            item.key = item.deptId;
            item.value = item.deptId.toString();
            item.selectable = false;
            item.children.map(tip => {
              tip.selectable = false;
              tip.title = tip.deptName;
              tip.selectable = false;
              tip.key = tip.deptId;
              tip.value = tip.deptId.toString();
              if (tip.children.length == 0 && tip.userList.length > 0) {
                tip.children = this.treeNodeChildren(tip.userList);
              }
              return tip;
            });
            return item;
          });
          this.treeData = this.treeData;
          this.total = 1000;
        });
      },
      treeNodeChildren(data) {
        let _this = this;
        let result = [];
        data.map((item, index) => {
          let json = item;
          json.title = item.nickName;
          json.selectable = true;
          json.key = "userId_" + item.userId;
          json.value = item.nickName;
          json.isLeaf = true;
          result.push(json);
        });
        return result;
      }
    },
    created() {
      this.findDeptList();
    }
  };
</script>

<style lang="scss" scoped>
	.detrusion {
		.title {
			padding: 82px 0 56px 0;
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
		}
		.detrusion-main {
			width: 510px;
			margin: 0 auto;
		}

		.dtree-select {
			height: 350px;
		}
	}
</style>